import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteNav from './components/SiteNav';
import { API_URL, groupByFirstLetter } from './utils/books';
import './App.css';

function AuthorsIndexPage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/books`)
      .then((response) => response.json())
      .then((data) => {
        setBooks(data.books || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const authors = useMemo(() => {
    const counts = {};
    books.forEach((book) => {
      const author = (book.author || 'Unknown').trim() || 'Unknown';
      counts[author] = (counts[author] || 0) + 1;
    });
    return Object.entries(counts).map(([name, count]) => ({ name, count }));
  }, [books]);

  const sections = useMemo(
    () => groupByFirstLetter(authors, (author) => author.name),
    [authors]
  );

  return (
    <div
      className="App index-page"
      style={{
        backgroundImage: `url('/background/background.png')`,
        backgroundColor: '#f0f0f0'
      }}
    >
      <SiteNav />
      <header className="App-header index-header">
        <div className="index-panel">
          <h2 className="index-title">Authors</h2>
          <p className="index-subtitle">Browse alphabetically. Click an author to see their books.</p>

          {loading && <p className="index-status">Loading authors...</p>}
          {error && <p className="index-status">Error: {error}</p>}

          {!loading && !error && sections.length === 0 && (
            <p className="index-status">No authors found.</p>
          )}

          {sections.map(({ letter, items }) => (
            <section key={letter} className="alpha-section" id={`authors-${letter}`}>
              <h3 className="alpha-heading">{letter}</h3>
              <ul className="alpha-list">
                {items.map((author) => (
                  <li key={author.name}>
                    <Link
                      className="alpha-list-button"
                      to={`/authors/${encodeURIComponent(author.name)}`}
                    >
                      <span className="alpha-list-title">{author.name}</span>
                      <span className="alpha-list-meta">
                        {author.count} {author.count === 1 ? 'book' : 'books'}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </header>
    </div>
  );
}

export default AuthorsIndexPage;
